import React from "react";
import { SCYData, SCYears } from "../../pages/homepage/theses/Stheses";

export default function FilterYears({ data, isChecked, oneSelect }) {
  // 1. Extraction et formatage des années
  const getFormattedYear = (date) => {
    if (Array.isArray(date)) {
      return date.map(d => d.getFullYear()).join(" - ");
    }
    return date.getFullYear();
  };

  // 2. Utilisation de Set pour les valeurs uniques
  const uniqueYears = [
    ...new Set(
      data.map(item => getFormattedYear(item.date))
    )
  ].sort((a, b) => {
    // 3. Tri plus robuste qui gère les intervalles "YYYY - YYYY"
    const yearA = typeof a === 'string' ? Math.max(...a.split(' - ').map(Number)) : a;
    const yearB = typeof b === 'string' ? Math.max(...b.split(' - ').map(Number)) : b;
    return yearB - yearA;
  });

  return (
    <SCYears>
      {uniqueYears.map((years, i) => (
        <SCYData
          key={`${years}-${i}`} // 4. Meilleure clé unique
          data-value={years}
          onClick={oneSelect}
          className={isChecked(years) ? "active" : ""}
          role="button" // 5. Accessibilité
          tabIndex={0} // 5. Accessibilité
        >
          {years}
        </SCYData>
      ))}
    </SCYears>
  );
}